// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Main_wrap__c69Aa","item":"Main_item__21RFC","item__video":"Main_item__video__3oT5v"};